import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ContentBlock from "../ContentBlock";
import ExhibitionsList from "../ExhibitionsList";
import { exhibitionsApiRequest } from "../../../api";

function Upcoming({ query, heading, id, onFetch }) {
  const defaultExhibitions = [];
  const [exhibitions, setExhibitions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // `defaultExhibitions` shouldn't be a dependency of this effect
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    function onSuccess(response) {
      const hasExhibitions = response.records && response.records.length > 0;
      setExhibitions(hasExhibitions ? response.records : defaultExhibitions);
      setIsLoading(false);
      onFetch("upcoming", "all", hasExhibitions);
    }

    const fetchData = () => {
      setIsLoading(true);
      exhibitionsApiRequest({ upcoming: true, all: true, ...query }, onSuccess);
    };

    fetchData();
  }, [query]);
  /* eslint-enable react-hooks/exhaustive-deps */

  if (exhibitions.length <= 0) return null;

  return (
    <ContentBlock heading={heading} id={id}>
      <ExhibitionsList
        exhibitions={exhibitions}
        isLoading={isLoading}
        showAll
      />
    </ContentBlock>
  );
}

Upcoming.displayName = "ExhibitionsLanding.Upcoming";

Upcoming.propTypes = {
  query: PropTypes.object,
  heading: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onFetch: PropTypes.func,
};

export default Upcoming;
